// extracted by mini-css-extract-plugin
module.exports = {"root":"InvoiceFormData_root__2Nu9H","paragraph":"InvoiceFormData_paragraph__2DVfw","accent":"InvoiceFormData_accent__3VaG3"};